import config from '../../config/config';

export const APMS_LOAD = 'APMS/APMS_LOAD';
export const APMS_SUCCESS = 'APMS/APMS_SUCCESS';
export const APMS_FAILURE = 'APMS/APMS_FAILURE';

export function getApmsFailureActionCreator(error) {
    return {
        error,
        type: APMS_FAILURE
    };
}

export function getApmsSuccessActionCreator(response) {
    return {
        apms: response.rows,
        type: APMS_SUCCESS
    };
}

export function getApms() {

    return {
        failureActionTypeOrCreator: getApmsFailureActionCreator,
        fetchParams: {
            url: `${config.apmApiUrl}/connectorList/public`
        },
        loadActionTypeOrCreator: APMS_LOAD,
        successActionTypeOrCreator: getApmsSuccessActionCreator
    };
}
